var exports = {
  "container": "xf0b3b88a--ab4cc7--container",
};

module.exports = exports;
